import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/system';

// Styled component for the banner
const BannerContainer = styled(Box)(({ theme, image }) => {
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        backgroundImage: image ? `url(${image})` : 'none',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        color: theme.palette.common.white,
        textAlign: 'center',
        position: 'relative',
        borderRadius: '12px',
    };
});

const Overlay = styled(Box)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(22, 124, 192, 0.58)',
    zIndex: 1,
    borderRadius: '12px'
});

const Content = styled(Box)({
    position: 'relative',
    zIndex: 2,
    maxWidth: '600px',
});

const Banner = ({ image, title, subtitle, buttonText, onButtonClick }) => {
    console.log('Image URL:', image);

    return (
        <BannerContainer image={image}>
            <Content>
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="h6" gutterBottom>
                    {subtitle}
                </Typography>
                {buttonText && (
                    <Button variant="contained" color="primary" onClick={onButtonClick}>
                        {buttonText}
                    </Button>
                )}
            </Content>
        </BannerContainer>
    );
};

export default Banner;

// Usage Example
// import Banner from './Banner';
//
// function App() {
//   return (
//     <Banner
//       image="https://via.placeholder.com/1920x400"
//       title="Welcome to Our Website"
//       subtitle="Your success starts here"
//       buttonText="Learn More"
//       onButtonClick={() => console.log('Button Clicked!')}
//     />
//   );
// }
//
// export default App;
